import {
    Box,
    Button,
    Container,
    FormControl,
    FormLabel,
    TextField,
    Typography,
} from '@material-ui/core'
import React, { useState } from 'react'
import {
    createStyles,
    makeStyles,
    Theme,
    useTheme,
} from '@material-ui/core/styles'
import { createChannel } from '../../../../store'
import LoopIcon from '@material-ui/icons/Loop'
import { useForm } from 'react-hook-form'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        closeBtn: {
            background: '#FFF',
            color: '#E9190F',
            border: '1px solid #E9190F',
            fontSize: '0.875rem',
            textTransform: 'inherit',
            fontWeight: 500,
            borderRadius: '5px',
            marginRight: '5px',
        },
        saveBtn: {
            background: '#008C85',
            color: '#FFF',
            border: '1px solid #008C85',
            fontSize: '0.875rem',
            textTransform: 'inherit',
            fontWeight: 500,
            borderRadius: '5px',
        },
        createChannelForm: {
            padding: '10px 0',
            '& .MuiFormControl-root': {
                margin: '5px 0',
            },
            '& .MuiFormLabel-root': {
                fontSize: '0.75rem',
                color: '#000',
                fontWeight: 700,
            },
            '& .MuiInputBase-input': {
                fontSize: '0.813rem',
            },
        },
        rotateIcon: {
            animation: 'spin 01s linear infinite',
        },
    }),
)

interface State {
    channelName: string
}

export const CreateChannelModal = (props: any) => {
    const classes = useStyles()
    const [isLoading, setIsLoading] = useState(false)

    const [values, setValues] = React.useState<State>({
        channelName: '',
    })

    const onSubmit = (data: any, event: any) => {
        event.preventDefault()
        setIsLoading(true)

        props
            .createChannel({
                body: {
                    name: data.channelName,
                    pair: false,
                },
            })
            .then((res: any) => {
                setIsLoading(false)
                setValues({ ...values, channelName: '' })
                props.handleClose()
            })
            .catch((err: any) => {
                setIsLoading(false)
            })
    }

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: 'all',
    })

    const handleChange = (
        prop: keyof State,
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setValues({ ...values, [prop]: event.target.value })
    }

    return (
        <>
            <Container style={{ padding: '0 8px' }}>
                <Typography
                    component="p"
                    style={{
                        fontSize: '0.75rem',
                        color: '#8A8A8A',
                        lineHeight: '1.9em',
                        margin: '15px 0',
                    }}
                >
                    Please enter a channel down below.
                </Typography>
                <form
                    noValidate
                    autoComplete="off"
                    className={classes.createChannelForm}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <FormLabel component="legend">Channel Name:</FormLabel>
                    <FormControl fullWidth>
                        <TextField
                            id="channel-name"
                            placeholder="Channel Name"
                            variant="outlined"
                            size="small"
                            {...register('channelName', {
                                required: true,
                                onChange: (
                                    event: React.ChangeEvent<HTMLInputElement>,
                                ) => handleChange('channelName', event),
                            })}
                            error={errors?.channelName?.type === 'required'}
                        />
                        <Box>
                            {errors.channelName &&
                                errors.channelName.type === 'required' && (
                                    <span className="error-message">
                                        This is required field
                                    </span>
                                )}
                        </Box>
                    </FormControl>

                    <div style={{ marginTop: '15px', textAlign: 'right' }}>
                        <Button
                            className={classes.closeBtn}
                            onClick={() => props.handleClose()}
                        >
                            Close
                        </Button>
                        <Button
                            variant="contained"
                            style={{
                                background: '#008C85',
                                color: '#FFF',
                                fontSize: '0.875rem',
                                textTransform: 'inherit',
                                fontWeight: 500,
                                borderRadius: '5px',
                                boxShadow: 'none',
                            }}
                            type="submit"
                        >
                            {isLoading ? (
                                <LoopIcon className={classes.rotateIcon} />
                            ) : (
                                'Save'
                            )}
                        </Button>
                    </div>
                </form>
            </Container>
        </>
    )
}
